<template lang="html">
  <b-form @submit="onSubmit" class="col-lg-9 col-page-content page-style-2">
    <div class="row">

      <div class="col-12">
        <div class="box-bubble">
          <div class="row">

            <div class="col-12 box-acc-title-s1">
              <h4>Seguridad</h4>
              <hr />
            </div>

            <b-form-group class="col-lg-12 custom-f-group-1" label="Email*" label-for="i-1">
              <b-form-input
                id="i-1"
                name="emailfront"
                v-model="form.email"
                type="email"
                placeholder=""
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Contraseña*" label-for="i-2">
              <div class="eye-box">
                <b-form-input
                  id="i-2"
                  name="passwordfront"
                  v-model="form.password"
                  type="password"
                  placeholder=""
                  required
                  autocomplete="off"
                ></b-form-input>
                <i class="fas ic-eye" v-bind:class="{ 'fa-eye' : showpass, 'fa-eye-slash' : !showpass }"  @click="showpass = !showpass"></i>
              </div>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Confirmar Contraseña*" label-for="i-3">
              <div class="eye-box">
                <b-form-input
                  id="i-3"
                  v-model="form.confirmpassword"
                  type="password"
                  placeholder=""
                  required
                ></b-form-input>
                <i class="fas ic-eye" v-bind:class="{ 'fa-eye' : showpasstwo, 'fa-eye-slash' : !showpasstwo }"  @click="showpasstwo = !showpasstwo"></i>
              </div>
            </b-form-group>
          </div>
        </div>

        <div class="mt-2 px-0 box-empty-bubble">
          <b-form-checkbox
            class="mb-3 custom-checkbox-s1"
            v-model="form.check"
            name="checkbox-1"
            value="accepted"
            unchecked-value="not_accepted"
            required>
            Al hacer clic en la casilla de verificación, acepta nuestros <router-link to="">Términos y condiciones</router-link> y <router-link to="">Política de privacidad</router-link>
          </b-form-checkbox>

          <b-button type="submit" class="btn-HelvNeu btn-squ-cur-1 btn-send">Actualizar accesos</b-button>
        </div>
      </div>

      <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
      </sweet-modal>
      <sweet-modal ref="modalAlert" :icon="modal.icon">
            <p>{{modal.msg}}</p>
             <br><br>
          <a class="btn btn-info" @click="$refs.modalAlert.close()">Aceptar</a>
      </sweet-modal>

    </div>
  </b-form>
</template>

<script>
export default {
  data(){
    return{
      form: {
        email: null,
        password: null,
        confirmpassword: null,
      },
       modal:{
          icon:null,
          msg:null
      },
      showpass:false,
      showpasstwo:false
    }
  },
  watch:{
      'showpass':function (val) {
          if (val == true) {
              $("#i-2").prop('type','text');
          }
          else if (val == false) {
            $("#i-2").prop('type','password');
          }
      },
      'showpasstwo':function (val) {
          if (val == true) {
              $("#i-3").prop('type','text');
          }
          else if (val == false) {
            $("#i-3").prop('type','password');
          }
      }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault()
      if (this.form.confirmpassword != this.form.password) {
          this.modal.icon = 'warning';
          this.modal.msg = 'Las contraseñas no coinciden';
          this.$refs.modalAlert.open();
          return;
      }
      this.$refs.modalLoading.open();
      axios.post(tools.url("/api/admin/updateProfilePassword"),this.form).then((response)=>{
            this.$root.auth();
            this.$refs.modalLoading.close();
            this.modal.icon = 'success';
            this.modal.msg = 'Información actualizada correctamente';
            this.$refs.modalAlert.open();


        }).catch((error)=>{
            this.$refs.modalLoading.close();
            this.modal.icon = 'error';
            this.modal.msg = 'Ocurrio un error al guardar la información';
            this.$refs.modalAlert.open();

        });
    },
    showPassword(){

    }

  },
  mounted(){
      this.form.email = this.$root.user.email;


  }
}
</script>
